import React from 'react';
import PropTypes from 'prop-types';

const EuroIcon = props => {
  const size = props.size || 24;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 20.6667C14.415 20.6681 12.8601 20.2335 11.5055 19.4104C10.151 18.5873 9.04892 17.4075 8.32 16H16V13.3333H7.44C7.37333 12.8933 7.33333 12.4533 7.33333 12C7.33333 11.5467 7.37333 11.1067 7.44 10.6667H16V8.00001H8.32C9.05021 6.59358 10.1526 5.41464 11.5068 4.59173C12.8611 3.76882 14.4153 3.33354 16 3.33334C18.1467 3.33334 20.12 4.12001 21.64 5.42667L24 3.06667C21.8045 1.08996 18.9542 -0.00266225 16 4.87139e-06C10.7733 4.87139e-06 6.34667 3.34667 4.69333 8.00001H0V10.6667H4.08C3.97202 11.5523 3.97202 12.4477 4.08 13.3333H0V16H4.69333C6.34667 20.6533 10.7733 24 16 24C19.08 24 21.88 22.84 24 20.9333L21.6267 18.5733C20.12 19.88 18.16 20.6667 16 20.6667Z"
        fill={props.color}
      />
    </svg>
  );
};

EuroIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default EuroIcon;
